import React from 'react';
import {FormGroup, Position, Switch} from '@blueprintjs/core';
import {Tooltip2} from '@blueprintjs/popover2';

import './SendWithAllAttachments.scss';

interface SendWithAllAttachmentsProps {
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
}

export const SendWithAllAttachments = ({
  value,
  onChange,
  disabled = false,
}: SendWithAllAttachmentsProps) => {
  return (
    <FormGroup label="" className="content__send-with-all-attachments">
      <Switch
        checked={value}
        onChange={(event: any) => onChange(event.target.checked)}
        disabled={disabled}
      />
      <Tooltip2
        content="If turned off, email will be sent if at least one attachment is successfully generated."
        position={Position.BOTTOM}
      >
        <div>Send only if all attachments are successfully generated.</div>
      </Tooltip2>
    </FormGroup>
  )
};

export default SendWithAllAttachments;
